import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'

// 路由配置
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // 路由懒加载
    component: () => import('../views/About.vue')
  },
  {
    path: '/empty',
    name: 'Empty',
    // 路由懒加载
    component: () => import('../views/Empty.vue')
  },
  {
    path: '/policy',
    name: 'Policy',
    // 路由懒加载
    component: () => import('../views/policy.vue')
  },
  {
    path: '/test',
    name: 'Test',
    // 测试路由
    component: () => import('../views/TestPage.vue')
  }
]

// 创建路由实例
const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
